import React from 'react';

/**
 * Site-wide notice. Presentational only: no props, no state, no storage. The TEXT is hardcoded
 * here — change it by editing this file and redeploying hosting. Keep the component: it is the
 * home page's notice slot (Home.tsx renders it above the sale grid) and will carry the next notice.
 * Renders nothing while there is no notice.
 *
 * History:
 *   2026-10-18  bidding-issues notice (investigating; email Dan).
 *   2026-10-21  dispute resolution sale dates + deadline, with links to the ruling (the sale's
 *               terms page) and the relist list. Deliberately no claim about causes or fixes —
 *               the banner carries dates and the deadline; the ruling document carries the account.
 *   2026-10-29  removed: the Bid Off (23–25 Oct) is over. No notice. The ruling stays reachable
 *               from the sale itself (/sale/H39uo0hbbQsClurrCTtm/info).
 *
 * Data-driven version (text from a document, no deploy to change it): post-Sunday, see POST-SUNDAY.md.
 */
const SiteNotice: React.FC = () => null;

export default SiteNotice;
